import { createFileRoute } from "@tanstack/react-router"

import { routeGuard } from "@/lib/routing/beforeLoad"

export const Route = createFileRoute("/_authlayout/spaceoverview")({
  beforeLoad: async ({ context }) => {
    await routeGuard(context, { allowCustomized: false })
  },
  loader: () => {
    // TODO: route preloaders
  }
})
